// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1619785527547
      var cssReload = require("/Users/admin/code/kegel24/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  